
<div #progressContainerWrapper
    class="col-12 p-0 ss-l-progress-container-wrapper ss-g-progreesBarStudio pl-0"
    
    style="width: 100%; position: absolute; bottom: 0 !important;"
    (mousedown)="onDragStart($event); $event.stopPropagation();"
    (mousemove)="onDragging($event); onProgressHover($event); $event.stopPropagation();"
    (mouseleave)="onProgressHoverEnd()"
    (touchstart)="onDragStart($event); $event.stopPropagation();"
    (touchmove)="$event.stopPropagation();"
    (mouseup)="onDragEnd($event); $event.stopPropagation();"
    (touchend)="onDragEnd($event); $event.stopPropagation();">

    <div #progressContainer class="ss-l-progress-container"
        (click)="$event.stopPropagation();"
        [ngClass]="{
            'ss-l-progress-container-fullscreen': isFullscreen,
            'ss-g-progress-container-preview': !isFullscreen
        }">

        <!-- Barra real (sem showProgressBar) -->
        <div #originalProgress class="ss-l-original-progress"
            [hidden]="showProgressBar"
            [ngStyle]="{'--progress-bar-color': progressBarColor}">
        </div>

        <!-- Barra fake (com showProgressBar) -->
        <div #parallelProgress class="ss-l-parallel-progress"
            [hidden]="!showProgressBar"
            [ngStyle]="{'--progress-bar-color': progressBarColor}">
        </div>

        <!-- Divisões de capítulo agora são "furos" recortados via mask no
             trilho/preenchimento (ver applyChapterMasks no .ts) — não existe
             mais elemento visual por capítulo aqui. -->

        <!-- Bolinha arrastável -->
        <div #marker
            (mousedown)="onDragStart($event); $event.stopPropagation();"
            (touchstart)="onDragStart($event); $event.stopPropagation();"
            class="absolute border-circle shadow-2 marker"
            style="width: 14px; height: 14px; cursor: pointer;"
            [ngStyle]="{ 'background-color': progressBarColor }">
        </div>
    </div>

    <div #speedControl class="ss-l-speed-control"
        (click)="$event.stopPropagation()"
        (mousedown)="$event.stopPropagation()"
        (touchstart)="$event.stopPropagation()">
        <button type="button" class="ss-l-speed-btn" [class.ss-l-speed-btn-active]="currentSpeed !== 1"
            (click)="cycleSpeed($event)" aria-label="Velocidade de reprodução">
            {{ currentSpeed }}x
        </button>
    </div>

    <!-- Tooltip do segmento de capítulo sob o cursor (hover, não confundir
         com o tooltip de drag emitido via tooltipChange) -->
    <div *ngIf="segmentTooltipVisible" class="ss-l-segment-tooltip"
        [style.left.px]="segmentTooltipX" [style.top.px]="segmentTooltipY">
        {{ segmentTooltipText }}
    </div>
</div>
